import React, { Fragment } from 'react';
import Dialog from '@material-ui/core/Dialog';
import {
  Fab, IconButton, Paper, Typography, useTheme,
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import TableCell from "@material-ui/core/TableCell"
import MomentUtils from '@date-io/moment';
import Add from '@material-ui/icons/Add';
import MenuItem from '@material-ui/core/MenuItem';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import EventDialog from './EventDialog';
import PromotionDialog from './PromotionDialog';
import ServiceDialog from './ServiceDialog';
import TrainerReviews from './TrainerReviews';

moment.tz.setDefault('Asia/Jerusalem');

const R = require('ramda');

const CreateDialog = React.forwardRef(function CreateDialog(props, ref) {
  const [open, setOpen] = React.useState(false);

  const handleCloseMenu = R.pathOr(() => {
  }, ['handleClose'])(props);

  function handleClickOpen() {
    setOpen(true);
    handleCloseMenu();
  }

  function handleClose() {
    setOpen(false);
  }

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const { action, type, data, company, refetch, ...other } = props;

  return (
    <>
      {props.action === 'reviews' && 
      <MenuItem onClick={handleClickOpen} ref={ref} {...other}>
      <Typography variant="body1" color="textSecondary">
       {props.data.avgRating ? String(props.data.avgRating).slice(0,4) :  "N/A"}
      </Typography>
    </MenuItem>}
      {props.action === 'create' && (
        <Fab
          style={{
            position: !fullScreen ? 'absolute' : 'relative',
            left: 0,
            padding: fullScreen ? null : '0px 24px',
            marginRight: 24,
          }}
          size="small"
          variant={fullScreen ? 'round' : 'extended'}
          color="primary"
          onClick={handleClickOpen}
          ref={ref}
          {...other}
        >
          <Add /> {fullScreen ? null : `Create ${props.type === 'event' ? 'Event' : props.type === 'service' ? "Service" : 'Promotion'}`}
        </Fab>

      )} {props.action === 'edit' && (
        <MenuItem onClick={handleClickOpen} ref={ref} {...other}>
          <Typography variant="body1" color="textSecondary">
            Edit
          </Typography>
        </MenuItem>
      )}

      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
        <Dialog
          maxWidth="sm"
          scroll="body"
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          {props.type === 'event'
            ? <EventDialog action={props.action} handleClose={handleClose} event={props.data} /> :
          props.type === 'promotion' ?  
             <PromotionDialog action={props.action} handleClose={handleClose} promotion={props.data} />
            : props.type === 'reviews' ?
            <TrainerReviews handleClose={handleClose} reviews={props.data.EventsRating} /> :
            <ServiceDialog action={props.action} handleClose={handleClose} service={props.data} company={props.company} refetch={props.refetch} />
          }
        </Dialog>
      </MuiPickersUtilsProvider>
    </>
  );
});

export default CreateDialog;

CreateDialog.defaultProps = {
  type: 'promotion',
  action: 'edit',
};
